import React from "react";
import {
  Input,
  Button,
  Space,
  Row,
  Col,
  Dropdown,
  Checkbox,
  Image,
  Modal,
  Tooltip,
  Avatar,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import GeofencesStore from "../store/GeofencesStore";
import { MapContainer, Popup, Circle, Polygon, Rectangle } from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import L from "leaflet";
import conf from "../config";
const dotIcon = L.divIcon({
  className: "dot-icon",
  iconSize: [8, 8],
  html: ' <div style="width: 20px; height: 20px; background-color: red; border-radius: 50%;"></div>',
});
dayjs.extend(customParseFormat);

class GeofencesList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.geofenceStore = new GeofencesStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      geofenceName: "",

      modalVisible: false,
      column: "",
      filter: "",
      showMap: false,
      company: false,
      modalInfoObj: [],

      selectedColumns: [
        {
          // title: 'Geofence Id',
          title: context.translate("_GEOFENCE_ID_"),
          dataIndex: "zoneId",
          key: "zoneId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: 'Geofence Name',
          title: context.translate("_FLEET_REPORTS_GEOFENCELIST_GEOFENCENAME_"),
          dataIndex: "name",
          key: "name",
          width: 22,
          ellipsis: {
            showTitle: true,
          },
          render: (name) => (
            <Tooltip placement="topLeft" title={name}>
              {name}
            </Tooltip>
          ),
        },

        {
          // title: 'Creation Date',
          title: context.translate("_FLEET_REPORTS_GEOFENCELIST_CREATIONDATE_"),
          dataIndex: "createDate",
          key: "createDate",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: 'Geofence Type',
          title: context.translate("_GEOFENCE_TYPE_"),
          dataIndex: "type",
          key: "type",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value == 1) {
              return "Polygon";
            } else if (value == 2) {
              return "Circle";
            } else if (value == 3) {
              return "Rectangle";
            }
          },
        },
        {
          // title: 'Customer Type',
          title: context.translate("_CUSTOMER_TYPE_"),
          dataIndex: "typeName",
          key: "typeName",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value == 1) {
              return "Retails";
            } else if (value == 2) {
              return "Food Service";
            }
          },
        },
        {
          // title: 'Bounds ',
          title: context.translate("_BOUNDS_"),
          dataIndex: "points",
          key: "points",
          width: 20,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: 'Radius ',
          title: context.translate("_RADIUS_"),
          dataIndex: "radius",
          key: "radius",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: 'View On Map ',
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "viewonmap",
          key: "viewonmap",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
          render: (value, obj) => {
            return (
              <>
                <Link
                  onClick={(e) =>
                    this.setState({ showMap: true, modalInfoObj: obj })
                  }
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link>
              </>
            );
          },
        },
      ],
    };
    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_CSV_")}
            </div>
          ),
          key: "csv",
        },
        // {
        //   label: (
        //     <div
        //       style={{
        //         display: "flex",
        //         alignItems: "center",
        //         gap: "5px",
        //       }}
        //     >
        //       {" "}
        //       <Image
        //         style={{ height: "18px", width: "18px", borderRadius: "0px" }}
        //         src={Excel}
        //       ></Image>
        //       {context.translate("_EXPORT_AS_XML_")}
        //     </div>
        //   ),
        //   key: "xml",
        // },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
          };
          if (val.key == "excel") {
            // console.log("afd")
            this.geofenceStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.geofenceStore.exportpdf(getData);
          }
          if (val.key == "csv") {
            this.geofenceStore.exportcsv(getData);
          }
          if (val.key == "xml") {
            this.geofenceStore.exportxml(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }
  async componentDidUpdate() {
    if (this.state.showMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    this.setState({ company: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });

    await this.handleSearch();
  }

  // async onSearch(value) {
  //     console.log(value)
  //     await this.setState({ emailId: value });
  //     this.handleSearch();
  // };

  async handleSearch() {
    this.setState({ loading: true });
    await this.geofenceStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
       userId:this.props.getUserData().userId,
     isadmin:this.props.getUserData().isadmin

    });

    await this.setState({ listUpdated: 1 });
    this.setState({ loading: false }); //need to reload data
  }

  showData = async () => {
    console.log(this.state.company);
    if (!this.state.companyId) {
      this.setState({ company: true });
    } else {
      this.setState({ company: false });
    }
    if (this.state.companyId) {
      this.setState({ company: false });
      await this.geofenceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        geofence: this.state.geofenceName,
      });
      await this.setState({ listUpdated: 1 });
    }
    // console.log(this.state.fromDate,this.state.toDate,)
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  searchInput = async (e) => {
    const value = e.target.value;

    // await this.setState({searchField:value})
    if (value.length >= 3) {
      await this.geofenceStore.loadData({
        geofence: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.geofenceStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        geofence: value,
        companyId: this.state.companyId,
      });
      await this.setState({ currentPage: 1 });
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.geofenceStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    const mapData = this.state.modalInfoObj.points?.split(",0,").map((val) => {
      return val.split(",").map((val) => Number(val));
    });

    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
             
              <div className="heading">
                {this.context.translate("_FLEET_REPORTS_GEOFENCELIST_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Dropdown menu={this.menuProps}>
                  <Button className="exportDropdown">
                    <Space>
                     
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>

                
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  // allowClear={true}
                  style={{ width: 200 }}
                  status={this.state.company ? "error" : false}
                />

                <Input
                  value={this.state.geofenceName}
                  style={{ width: 200, borderRadius: "25px" }}
                  // placeholder='Search By Geofence Name'
                  placeholder={this.context.translate(
                    "_SEARCH_BY_GEOFENCE_NAME_"
                  )}
                  onChange={(e) => {
                    this.setState({ geofenceName: e.target.value });
                    this.searchInput(e);
                  }}
                />
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Dropdown
                  disabled={
                    this.geofenceStore?.geofencesReport?.length > 0
                      ? false
                      : true
                  }
                  menu={this.menuProps}
                >
                  <Button className="downloadExcelButton">
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.geofenceStore?.total}
            columns={this.state.column}
            dataSource={this.geofenceStore?.geofencesReport}
            loading={this.geofenceStore?.loading}
            onChange={this.handleTableChange}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          {this.state.showMap && (
            <Modal
              // title="Geofence on Map"
              title={this.context.translate("_FLEET_GEOFENCE_REPORT_")}
              open={this.state.showMap}
              centered
              // bodyStyle={{ height: 1000 }}
              width={850}
              height={400}
              onOk={() => this.setState({ showMap: false })}
              onCancel={() => this.setState({ showMap: false })}
              footer={false}
            >
              {this.state.modalInfoObj?.points?.length > 2 ? (
                <MapContainer
                  ref={this.mapRef}
                  zoom={15.3}
                  // center={[24.7136, 46.6753]}
                  center={[
                    this.state.modalInfoObj?.points?.split(",")[0] ||
                      conf.mapCenter,
                    this.state.modalInfoObj?.points?.split(",")[1] ||
                      conf.mapCenter,
                  ]}
                  style={{ height: "400px", width: "800px" }}
                  zoomControl={false}

                  // bounds={this.state.modalInfoObj ? [[this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude], [this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude]] : []}
                >
                  {/* <ZoomControl position="bottomRight"></ZoomControl> */}
                  <ReactLeafletGoogleLayer />

                  {this.state.modalInfoObj?.points &&
                    this.state.modalInfoObj?.type == 1 && (
                      <Polygon
                        // positions={this.state.modalInfoObj?.points}
                        positions={mapData}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{this.state.modalInfoObj?.name}</Popup>
                      </Polygon>
                    )}

                  {this.state.modalInfoObj?.type == 2 &&
                    this.state.modalInfoObj?.points && (
                      <Circle
                        center={{
                          lat:
                            this.state.modalInfoObj?.points.split(",")[0] || 0,
                          lng:
                            this.state.modalInfoObj?.points.split(",")[1] || 0,
                        }}
                        radius={this.state.modalInfoObj?.radius}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{this.state.modalInfoObj?.name}</Popup>
                      </Circle>
                    )}

                  {this.state.modalInfoObj?.type == 3 &&
                    this.state.modalInfoObj?.points && (
                      <Rectangle
                        bounds={mapData}
                        pathOptions={{ color: "red" }}
                      ></Rectangle>
                    )}
                </MapContainer>
              ) : (
                <MapContainer
                  ref={this.mapRef}
                  zoom={15.3}
                  // center={[24.7136, 46.6753]}
                  center={conf.mapCenter}
                  style={{ height: "400px", width: "800px" }}
                  zoomControl={false}

                  // bounds={this.state.modalInfoObj ? [[this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude], [this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude]] : []}
                >
                  {/* <ZoomControl position="bottomRight"></ZoomControl> */}
                  <ReactLeafletGoogleLayer />
                </MapContainer>
              )}
            </Modal>
          )}
        </div>
      </>
    );
  }
}
GeofencesList.contextType = StoreContext;
export default observer(withRouter(GeofencesList));
